// removed by extract-text-webpack-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","title":"title-3VBPD","sectionTitle":"sectionTitle-3hwpb","sectionContent":"sectionContent-1O6Xy","footerLink":"footerLink-3tEbW","finePrint":"finePrint-3zjzB","warningClass":"warningClass-31A24","bigLink":"bigLink-Rx4kw","privacyWrapper":"privacyWrapper-2mAkS","privacyFooter":"privacyFooter-LkBNc","webFooterWrapper":"webFooterWrapper-3G236","webFooter":"webFooter-38mPR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/privacy_center/util/_privacyStyles.css
// module id = 113
// module chunks = 1